function NotFound() {
  return <p>Not Found</p>;
}

export default NotFound;
